export enum FrageRauchen {
  KEINE_PRAEFERENZ = 'keine_praeferenz',

  JA = 'ja',

  ABER_NUR_DRAUSSEN = 'aber_nur_draussen',

  NEIN = 'nein',
}
